import React, { useEffect, useRef, useState, useCallback } from "react";
import { Definition } from "../../../../../../data/Definition";
import Stats from "../../../../components/Elements/Stats";
import Widget from "../../../../components/Elements/Widget";
import { useStore } from "../../../../providers/AppProvider";
import { Field, StatValue } from "../../../../types/types";
import { SETTING_SEASON_YEAR } from "../../../../utils/settings";
import { useGetAllZones } from '../../../../api/getAllZones';
import { Zone } from '../../../../types/types';
import { dcRound } from "../../../../utils/misc";
import { queryDwZoneVVIcVariance, queryDwZoneChange } from "../../../../utils/dwHelpers";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faPencilAlt, faDownload, faPlus, faEye } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import _ from "lodash";
import { DeleteZone} from "./DeleteZone";

interface ZoneManagementSelectorProps {
    field: Field;
    setZones: Function;
    zones: Zone[] | null;
    selectedZoneName: string | null;
    setSelectedZoneName: Function;
    selectedZoneSetId: string | null;
    setSelectedZoneSetId: Function;
    selectedZoneSetIndex: number;
    setSelectedZoneSetIndex: Function;
    selectedDate: string | null;
    zoneData: any;
    setZoneData: Function;
    onEditZonsetClicked: Function;
    zonesVisibility: boolean;
    setZonesVisibility: Function;
}

const CACHE_SIZE = 20;

const ZoneManagementSelector = ({ onEditZonsetClicked, field, setZones, zones, selectedZoneName, selectedZoneSetId, setSelectedZoneSetId, selectedZoneSetIndex, setSelectedZoneSetIndex, setSelectedZoneName, selectedDate, zoneData, setZoneData, zonesVisibility, setZonesVisibility }: ZoneManagementSelectorProps) => {

    const [zonesGeoData, setZonesGeoData] = useState<any | null>(null);
    const [updateSelctorIncrement, setUpdateSelctorIncrement] = useState<number>(0);
    const [updateZoneDataIncrement, setUpdateZoneDataIncrement] = useState<number>(0);
    const [vigorValue, setVigorValue] = useState<any>(null);
    const [stressValue, setStressValue] = useState<any>(null);
    const [varValue, setVarValue] = useState<any>(null);
    const [changeValue, setChangeValue] = useState<any>(null);
    const [zonesPrepped, setZonesPrepped] = useState<any>(null);

    const { data: _zones, refetch: _refetch_zones } = useGetAllZones(field.id); 
    const { state, loading, settings } = useStore();
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const [dataChangeLoading, setDataChangeLoading] = useState<boolean>(false);
    const [showActions, setShowActions] = useState<boolean[]>([]);
    const { current: cache} = useRef({})

    useEffect(() => {
        console.log("X040624 queue zone data queries on", selectedZoneSetId)
        if(loading || !field || !zones || !selectedZoneSetId || !settings[SETTING_SEASON_YEAR]) {
            return;
        }
        console.log("X040624 Re queuing zone data queries on",selectedZoneSetId)
        const definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('zone'));

        if(!definition) {
            console.error('Unable to find field definition');
            return;
        }else{
            console.log("B032924 definition", definition)
        }
        let metric = "variability";
        let metric_change = "variability_change";
        const key = [field.ext_id!, settings[SETTING_SEASON_YEAR], metric].join("_");
        
        //if(!cache.hasOwnProperty(key)) {
            setDataLoading(true);
            setDataChangeLoading(true);
            _load(field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition).then(result => { 
                //setData(result.filter((zone: any) => zone.zone_name === selectedZoneName);
                //setDataAllZones(result);
                console.log("B050624 variability result", result);
                console.log("X040624 zoneData", zoneData);

                setDataLoading(false);
                //cache[key] = result;
                console.log("041924 setZoneData B", zoneData, metric, result);
                setZoneData((prevZoneData:any) => ({
                    ...prevZoneData, 
                    [metric]: {
                        "dataAllZones":result,
                    }
                }))
                //setUpdateZoneDataIncrement(prev => prev + 1);
            });
            _load_change(field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition).then(result => { 
                //setData(result.filter((zone: any) => zone.zone_name === selectedZoneName);
                //setDataAllZones(result);
                console.log("B050624 variability_change result", result);
                console.log("X040624 zoneData", zoneData);

                setDataChangeLoading(false);
                //cache[key] = result;
                console.log("041924 setZoneData C", zoneData, metric, result);
                setZoneData((prevZoneData:any) => ({
                    ...prevZoneData, 
                    [metric_change]: {
                        "dataAllZones":result,
                    }
                }))
                //setUpdateZoneDataIncrement(prev => prev + 1);
            });
        /*} else {
            if(Object.keys(cache).length > CACHE_SIZE) {
                for(const k in cache) {
                    delete cache[k];
                }
            }
            //setData(cache[key]);
            setZoneData((prevZoneData:any) => ({
                ...prevZoneData, 
                [metric]: {
                    "dataAllZones":cache[key], 
                }
            }));
        }*/

    }, [/*loading, zones, selectedZoneName, settings[SETTING_SEASON_YEAR],*/ selectedZoneSetId, field]);

    useEffect(() => {
        console.log("A061824 zones", zones)
        console.log("A061824 field", field)
        if (!zones || zones.length === 0 || zones[0].fieldId !== field.id){
            console.log("A061824 refetching zones [field]")
            _refetch_zones();
        }
    }, [field]);

    /*useEffect(() => {
        console.log("A061824 zones", zones)
        console.log("A061824 refetching zones []")
        if (!zones || zones.length === 0){
            _refetch_zones();
        }
    }, []);*/

    const _load = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwZoneVVIcVariance(extId, definition, metric, dtStart, dtEnd, selectedZoneSetId);
        console.log("B040124 data", data)
        if(data) {
            return data;
        }

        return null;
    }
    const _load_change = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwZoneChange(extId, definition, metric, dtStart, dtEnd, selectedZoneSetId);
        console.log("B040124 data", data)
        if(data) {
            return data;
        }

        return null;
    }

    useEffect(() => {
        console.log("A060424 _zones", _zones);
        setZones(_zones);
        if (_zones && _zones.length > 0){
            let selectedIndex = 0;
            if (_zones[selectedZoneSetIndex]){
                selectedIndex = selectedZoneSetIndex;
            }else{
                setSelectedZoneSetIndex(0);
            }
            console.log("041924 selectedIndex", selectedIndex);
            console.log("041924 _zones[selectedIndex]", _zones[selectedIndex]);
            setZonesGeoData(_zones[selectedIndex].geojson.features.sort((a:any, b:any) => {
                if (a.properties.label < b.properties.label) {
                return -1;
                }
                if (a.properties.label > b.properties.label) {
                return 1;
                }
                return 0; // If 'a' and 'b' are equal
            }));
        }else{
            setZonesGeoData([]);
        }
        if (_zones && _zones.length > 0){
            const sortedZones = _zones.map((_zone: any) => {
                console.log("E040624 _zone", _zone);
                const sortedZone = _zone.geojson.features.sort((a: any, b: any) => {
                    if (a.properties.label < b.properties.label) {
                        return -1;
                    }
                    if (a.properties.label > b.properties.label) {
                        return 1;
                    }
                    return 0; // If 'a' and 'b' are equal
                });
                console.log("E040624 sortedZone", sortedZone);
                return {
                    "zoneGeo":sortedZone,
                    "zoneData": _zone,
                }
            });
            console.log("E040624 sortedZones", sortedZones);
            setZonesPrepped(sortedZones);
        }else{
            setZonesPrepped([]);
        }
    }, [_zones, selectedZoneSetIndex]);

    useEffect(() => {
        console.log("B050124 zoneData", zoneData);
        console.log("B050124 selectedDate", selectedDate);
        let tempStressValues = {};
        if (zoneData && zoneData?.stress?.dataAllZones && selectedDate) {
            zoneData.stress.dataAllZones.forEach((_zoneData:any) => {
                console.log("B050124 _zoneData --> ", _zoneData);
                console.log("B050124 selectedDate --> ", selectedDate);
                let selectedDateIndex = _zoneData?.row.stress_date.findIndex((date:string) => date.startsWith(selectedDate));
                console.log("B050124 selectedDateIndex --> ", selectedDateIndex);
                //tempStressValues[_zoneData?.row.zone_name] = _zoneData?.row.stress_mean[selectedDateIndex];
                tempStressValues[_zoneData?.row.zone_name] = _zoneData?.values[selectedDateIndex];
            })
        }
        console.log("B050124 tempStressValues --> ", tempStressValues);
        setStressValue(tempStressValues);

        let tempVigorValues = {};
        if (zoneData && zoneData?.productivity?.dataAllZones && selectedDate) {
            zoneData.productivity.dataAllZones.forEach((_zoneData:any) => {
                console.log("C040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.row.productivity_date.findIndex((date:string) => date.startsWith(selectedDate));
                if (selectedDateIndex && selectedDateIndex > -1 && _zoneData?.row?.productivity_mean_transformed){
                    tempVigorValues[_zoneData?.row.zone_name] = _zoneData?.row.productivity_mean_transformed[selectedDateIndex];
                }
            })
        }
        console.log("A050124 tempVigorValues --> ", tempVigorValues);
        setVigorValue(tempVigorValues);
        
        let tempVarValues = {};
        if (zoneData && zoneData?.variability?.dataAllZones && selectedDate) {
            zoneData.variability.dataAllZones.forEach((_zoneData:any) => {
                console.log("C040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.dates.findIndex((date:string) => date.startsWith(selectedDate));
                tempVarValues[_zoneData?.row.zone_name] = _zoneData?.values[selectedDateIndex];
            })
        }
        console.log("A050124 tempVarValues --> ", tempVarValues);
        setVarValue(tempVarValues);

        let tempChangeValues = {};
        if (zoneData && zoneData?.variability_change?.dataAllZones && selectedDate) {
            zoneData.variability_change.dataAllZones.forEach((_zoneData:any) => {
                console.log("D040124 _zoneData --> ", _zoneData);
                let selectedDateIndex = _zoneData?.dates.findIndex((date:string) => date.startsWith(selectedDate));
                tempChangeValues[_zoneData?.row.zone_name] = _zoneData?.values[selectedDateIndex];
            })
        }
        console.log("A050124 tempChangeValues --> ", tempChangeValues);
        setChangeValue(tempChangeValues);

        setUpdateSelctorIncrement(prev => prev + 1);
    }, [zoneData, selectedDate, updateZoneDataIncrement]);

    useEffect(() => {
        console.log("B040124 vigorValue", vigorValue);
    }, [vigorValue]);

    useEffect(() => {
        console.log("E040624 zonesGeoData", zonesGeoData);
        if (zonesGeoData && zonesGeoData.length > 0) {
            console.log("Z040624 F > zonesGeoData[0].properties.label", zonesGeoData[0].properties.label);
            console.log("Z040624 F > zonesGeoData", zonesGeoData);
            setSelectedZoneName(zonesGeoData[0].properties.label)
            setUpdateSelctorIncrement(prev => prev + 1);
        }
    }, [zonesGeoData]);

    useEffect(() => {
        setZones(zones);
    }, [zones]);

    useEffect(() => {
        console.log("A040924 zonesPrepped", zonesPrepped);
        if (zonesPrepped && zonesPrepped.length > 0){
            console.log("A040924 zonesPrepped.map((zone: any, i:number) => { return i})", zonesPrepped.map((zone: any, i:number) => { return false}));
            setShowActions(zonesPrepped.map((zone: any, i:number) => { return false}))
        }
    }, [zonesPrepped]);

    useEffect(() => {
        console.log("040224 showActions", showActions);
    }, [showActions]);

    useEffect(() => {
        setUpdateSelctorIncrement(prev => prev + 1);
    }, [selectedZoneName]);

    const setSelectedZone = (zone: any) => {
        console.log("Z040624 A");
        setSelectedZoneName(zone.properties.label);
    }

    const onEditClicked = (e:any) => {
        e.stopPropagation();
        console.log("B040224 onEditClicked", e)
        if(onEditZonsetClicked) {
            onEditZonsetClicked(e, "edit");
        }
    }

    const onDownloadClicked = (e:any, i:number) => {
        e.stopPropagation();
        console.log("X040624 A zonesPrepped[i].zoneData.s3Uri", zonesPrepped[i].zoneData.s3Uri)
        const s3Url = zonesPrepped[i].zoneData.s3Uri;
        if (s3Url){
            window.open(s3Url, '_blank'); 
        }
    }

    const onViewClicked = (e:any, i:number) => {
        e.stopPropagation();
        console.log("A061824 onViewClicked", e, i)
        console.log("A061824 A zonesPrepped[i]", zonesPrepped[i])
        setSelectedZoneSetId(zonesPrepped[i].zoneData.entityId);
        setSelectedZoneSetIndex(i);
        /*if(onEditZonsetClicked) {
            onEditZonsetClicked(e, "edit");
        }*/
    }
    const onNewClicked = (e:any) => {
        e.stopPropagation();
        console.log("B040224 onEditClicked", e)
        if(onEditZonsetClicked) {
            onEditZonsetClicked(e, "new");
        }
    }
    const updateSetShowActionsTrue = useCallback(_.debounce((index:number, action:boolean) => {
        console.log("A040924 updateSetShowActions", index, action)
        let tempShowActions = zonesPrepped.map((zone: any) => { return false}); //showActions;
        tempShowActions[index] = action;
        setShowActions(tempShowActions);
        setUpdateSelctorIncrement(prev => prev + 1);
    }, 10), [showActions]);
    const updateSetShowActionsFalse = /*useCallback(_.debounce(*/(index:number, action:boolean) => {
        console.log("A040924 updateSetShowActions", index, action)
        let tempShowActions = zonesPrepped.map((zone: any) => { return false}); 
        tempShowActions[index] = action;
        setShowActions(tempShowActions);
        setUpdateSelctorIncrement(prev => prev + 1);
    }//, 0), [showActions]);
    
    return (<>
            <div
                style={{
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    backgroundColor: "#f7f7f7",
                    position: "relative",
                }}
                className="card mb-2"
                onMouseLeave={() => updateSetShowActionsFalse(1, false)}
            >
                <div className="card-header" style={{display: "flex"}}>
                    <input
                        key={`key_zones_vis`}
                        id={"zones_vis_layer_id"}
                        //className="form-check-input"
                        type="checkbox"
                        checked={zonesVisibility}
                        style={{marginTop: "0px"}}
                        onChange={evt => {
                            console.log("A061324 evt.target.checked", evt.target.checked)
                            console.log("A061324 evt.target", evt.target)
                            console.log("A061324 zonesVisibility", zonesVisibility)
                            setZonesVisibility(evt.target.checked)
                        }}
                    />
                    <div style={{paddingLeft: "5px"}}>
                        Zones
                    </div>
                </div>
            {zonesPrepped && zonesPrepped.length > 0 
            ? zonesPrepped.map((zone: any, i:number) => {
                const zoneGeo = zone.zoneGeo;
                const zoneData = zone.zoneData;
                //console.log("F040624 zoneGeo", zoneGeo, i)
                //console.log("F040624 zoneData", zoneData, i)
                //console.log("F040624 selectedZoneSetIndex", selectedZoneSetIndex)
                return (
                    <div
                    key={`selectorgrandparent${i}_${updateSelctorIncrement}`}
                    style={{
                        paddingBottom:"0px",
                        marginBottom:"0px",
                        border: "1px #e6e6e6 solid",
                        //borderRadius: "4px",
                        backgroundColor: "#fff",
                    }}
                >
                    <div
                        onMouseEnter={() => updateSetShowActionsTrue(i, true)}
                        //onMouseLeave={() => updateSetShowActionsFalse(i, false)}
                        key={`selectorparent${i}_${updateSelctorIncrement}`}
                        style={{
                            paddingTop:"15px",
                            paddingBottom:"15px",
                            paddingLeft:"15px",
                            paddingRight:"15px",
                            //marginBottom:"10px",
                            borderTopLeftRadius: "4px",
                            borderTopRightRadius: "4px",
                            backgroundColor: "#fff",
                            position: "relative",
                            cursor:"pointer",
                        }}
                    >{`${zoneData.name}`}
                        { showActions[i] && 
                        <div 
                            className="d-flex" 
                            style={{ position:"absolute", right:"5px", top:"15px", height:"30px"}}
                        >
                            {selectedZoneSetIndex !== i 
                            ? <div title="View" 
                                onClick={(e) => onViewClicked(e, i)} 
                                className="text-sm align-items-center bg-primary d-flex flex-lg-row justify-content-center rounded-circle text-white ml-2" 
                                style={{width: '25px', height: '25px', cursor:'pointer'}}>
                                <FontAwesomeIcon icon={faEye} />
                            </div>
                            : null}
                            <div title="Edit" 
                                onClick={(e) => onEditClicked(e)} 
                                className="text-sm align-items-center bg-success d-flex flex-lg-row justify-content-center rounded-circle text-white ml-2" 
                                style={{width: '25px', height: '25px', cursor:'pointer'}}>
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </div>
                            {zoneData.s3Uri
                            ? <div title="Download Zoneset" 
                                onClick={(e) => onDownloadClicked(e, i)} 
                                className="text-sm align-items-center bg-success d-flex flex-lg-row justify-content-center rounded-circle text-white ml-2" 
                                style={{width: '25px', height: '25px', cursor:'pointer'}}>
                                <FontAwesomeIcon icon={faDownload} />
                            </div>
                            : <></>}
                            {/*<DeleteZone zoneId={selectedZoneSetId} />*/}
                        </div>}
                    </div>
                    {/*(zoneGeo && zoneGeo.length !== 0 && selectedZoneSetIndex === i) 
                    ?(console.log("G040624 zoneGeo", zoneGeo, i),
                    console.log("G040624 zoneData", zoneData, i),
                    console.log("G040624 selectedZoneSetIndex", selectedZoneSetIndex))
                    : null
                    */}
                    {(zoneGeo && zoneGeo.length !== 0 && selectedZoneSetIndex === i) 
                        ? zoneGeo.map((zone: any, i2:number) => {
                            console.log("GG040624 zone", zone, i2, zoneGeo.length)
                                let _color = (selectedZoneName === zone.properties.label) ? "#fff" : "#000";
                                let _backgroundColor = (selectedZoneName === zone.properties.label) ? "#000" : "#fff";
                                let _lineBackgroundColor = (selectedZoneName === zone.properties.label) ? "#e6e6e6" : "#fff";
                                let _border = `1px solid #000`;
                                let _borderBottom = `${zoneGeo.length === (i2 + 1) ? "0" : "1" }px solid #e6e6e6`;
                                let _borderTop = `${1 === (i2 + 1) ? "1" : "0" }px solid #e6e6e6`;
                                return (
                                    <div
                                        className="zone-stat-line"
                                        key={`div_${i}_${i2}_${updateSelctorIncrement}_${zone.properties.label}`}
                                        style={{
                                            width:"100%",
                                            height: "45px",
                                            borderBottom: _borderBottom,
                                            borderTop: _borderTop,
                                            backgroundColor: _lineBackgroundColor,
                                        }}
                                    >
                                        <div
                                            key={`selector${updateSelctorIncrement}_${zone.properties.label}`}
                                            style={{
                                                color: _color,
                                                backgroundColor: _backgroundColor,
                                                border: _border,
                                                width:"35px",
                                                height: "35px",
                                                borderRadius: "20px",
                                                fontWeight: "normal",
                                                lineHeight: "35px",
                                                textAlign: "center",
                                                cursor:"pointer",
                                                marginBottom: "0px",
                                                //paddingTop: i === 0 ? "10px" : "0px",
                                            }}
                                            onClick={() => setSelectedZone(zone)}
                                        >
                                            {zone.properties.label}
                                            {console.log("GG040624 vigorValue, stressValue, varValue, changeValue", vigorValue, stressValue, varValue, changeValue)}
                                        </div>
                                        <div className="zone-stat-stat" key={`vigor_${i}_${updateSelctorIncrement}_${zone.properties.label}_selector`}>
                                            <div className="zone-stat-value">{vigorValue[zone.properties.label] ? dcRound(vigorValue[zone.properties.label], undefined, undefined, true) : vigorValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                            <div className="zone-stat-name">biomass</div>
                                        </div>
                                        <div className="zone-stat-stat" key={`stress_${i}_${updateSelctorIncrement}_${zone.properties.label}_selector`}>
                                            <div className="zone-stat-value">{stressValue[zone.properties.label] ? dcRound(stressValue[zone.properties.label], undefined, undefined, true) : stressValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                            <div className="zone-stat-name">stress</div>
                                        </div>
                                        <div className="zone-stat-stat" key={`var_${i}_${updateSelctorIncrement}_${zone.properties.label}_selector`}>
                                            <div className="zone-stat-value">{varValue[zone.properties.label] ? dcRound(varValue[zone.properties.label], undefined, undefined, true) : varValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                            <div className="zone-stat-name">var</div>
                                        </div>
                                        <div className="zone-stat-stat" key={`change_${i}_${updateSelctorIncrement}_${zone.properties.label}_selector`}>
                                            <div className="zone-stat-value">{changeValue[zone.properties.label] ? dcRound(changeValue[zone.properties.label], undefined, undefined, true) : changeValue[zone.properties.label] === 0 ? 0 : "n/a"}</div>
                                            <div className="zone-stat-name">change</div>
                                        </div>
                                    </div>
                                )
                            })
                        : selectedZoneSetIndex !== i
                            ? null 
                            : <div
                            key={`selectorgrandparent${i}_${updateSelctorIncrement}`}
                            style={{
                                padding:"15px",
                                marginBottom:"10px",
                                border: "1px #e6e6e6 solid",
                                //borderRadius: "4px",
                                backgroundColor: "#fff",
                            }}
                            >No zones available</div>   
                        }
                    </div>
                )
            })
            : <div
                key={`selectorgrandparent_${updateSelctorIncrement}`}
                style={{
                    padding:"15px",
                    marginBottom:"0px",
                    border: "1px #e6e6e6 solid",
                    //borderRadius: "4px",
                    backgroundColor: "#fff",

                }}
            >No zone sets available</div>
            }
     <div
        style={{
            paddingTop:"5px",
            paddingBottom:"5px",
            paddingLeft:"5px",
            paddingRight:"5px",
        }}>
        <Button
            variant="success"
            id="add-field"
            className="w-100"
            onClick={(e:any) => onNewClicked(e)} 
            >
            <FontAwesomeIcon icon={faPlus} /> Add Zone Set
        </Button>
    </div>
    </div></>
    )
}

export default ZoneManagementSelector;